import { render, staticRenderFns } from "./CardModulos.vue?vue&type=template&id=6de4558e&scoped=true"
import script from "./CardModulos.vue?vue&type=script&lang=js"
export * from "./CardModulos.vue?vue&type=script&lang=js"
import style0 from "./CardModulos.vue?vue&type=style&index=0&id=6de4558e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4558e",
  null
  
)

export default component.exports